/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import { useState, memo } from 'react'
import TruncateMarkup from 'react-truncate-markup'
import convert from 'htmr'

import { SecondaryButton } from '../buttons'

export type ExpandableDataProps = {
  /** Data of field */
  data: string
}

const MAX_LINES = 10000
const dataCss = css`
  white-space: pre-wrap;
`

/**
 * Use to handle large pieces of text that need to be truncated and allowed to expand.
 * Correctly handles HTML element internal to the text, including truncated Anchor elements that are still linkable.
 */
const ExpandableData = ({ data }: ExpandableDataProps) => {
  const [expanded, setExpanded] = useState(false)
  const [truncated, setTruncated] = useState(false)
  const onShowMore = () => setExpanded(true)
  const onShowLess = () => setExpanded(false)
  const ellipsis = (
    <span>
      ... <SecondaryButton onClick={onShowMore}>Read More</SecondaryButton>
    </span>
  )

  const onTruncate = (newTruncated: boolean) => {
    if (truncated !== newTruncated) {
      setTruncated(newTruncated)
    }
  }

  if (!data) {
    return null
  }

  // see https://github.com/parsable/react-truncate-markup/issues/19 on why
  // we have to use htmr instead of dangerouslySetInnerHTML
  // chromatic-ignore force chromatic to ignore this element.
  // we do this because there a non-deterministic UI issue with the truncation.
  return (
    <div className="chromatic-ignore" css={dataCss}>
      <TruncateMarkup lines={expanded ? MAX_LINES : 10} ellipsis={ellipsis} onTruncate={onTruncate}>
        <span>{convert(data.toString())}</span>
      </TruncateMarkup>
      {!truncated && expanded && <SecondaryButton onClick={onShowLess}>Show Less</SecondaryButton>}
    </div>
  )
}

export default memo(ExpandableData)
